<template>
  <MglMap
    id="mapContainer"
    :accessToken="accessToken"
    :mapStyle="mapStyle"
    :center="coordinates"
    :zoom="6"
    :navigationControl="true"
  >
    <MglNavigationControl position="top-right" />
    <span v-for="(task, index) in taskCoordinates" :key="index">
      <MglMarker :coordinates="task.coordinates" color="#1e345d" @click="selectTask(task)" />
    </span>
  </MglMap>
</template>

<script>
import Mapbox from 'mapbox-gl'
import { MglMap, MglMarker, MglNavigationControl } from 'vue-mapbox'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'MapView',
  components: {
    MglMap,
    MglNavigationControl,
    MglMarker
  },
  data: () => ({
    map: null,
    accessToken: 'pk.eyJ1Ijoicm9iY2xpZmZvcmQiLCJhIjoiY2p6eGJyNHlzMTV3MjNjbXYzbDV5dXZtNyJ9.beJcHjDQnuu9Lbkg0sJiug',
    mapStyle: 'mapbox://styles/mapbox/outdoors-v11',
    coordinates: [-121.409, 49.700]
  }),
  methods: {
    ...mapActions({
      select: 'workOrderTask/getTask',
      getTaskColor: 'workOrderTask/getTaskColor'
    }),
    created () {
      this.mapbox = Mapbox
    },
    selectTask (task) {
      this.select(task.id)
    }
  },
  computed: {
    ...mapGetters({
      tasks: 'workOrderTask/taskLocationList',
      selected: 'workOrderTask/selectedTask'
    }),
    taskCoordinates () {
      return this.tasks.map(task => {
        task.coordinates = [task.longitude, task.latitude]
        return task
      })
    }
  }
}
</script>
<style>
  .mapboxgl-ctrl-top-right .mapboxgl-ctrl {
    margin: 14px 12px 0 0 !important;
  }
  .mapboxgl-canvas {
    height: 100% !important;
  }
  .mapboxgl-marker:hover {
    cursor: pointer;
  }
</style>
